import { GiReceiveMoney } from "react-icons/gi";

const MoneyIcon = (props) => {
  return <GiReceiveMoney className={props.className} />;
};

export default MoneyIcon;
